module.exports = __webpack_public_path__ + "./img/select-choices-info.svg";